import keys from 'lodash/keys'
import isEmpty from 'lodash/isEmpty'
import { FilterTypes } from '../../types/Main'

const applyFilters = ({ tags, properties, sort, minPrice, maxPrice }: Record<FilterTypes, any>) => {
  let searchString = ''

  if (window.location.search.includes('q=')) {
    searchString += `q=${new URLSearchParams(window.location.search).get('q')}`
    searchString += '&'
  }

  const tagsType = keys(tags)
  tagsType.forEach((tagType) => {
    tags[tagType].forEach((tag: String) => {
      searchString += `type_tags[${tagType}][]=${tag.replace('&', '%26')}`
      searchString += '&'
    })
  })

  const propertiesName = keys(properties)
  propertiesName.forEach((propertyName) => {
    properties[propertyName].forEach((property: String) => {
      searchString += `${propertyName}_values[]=${property.replace('&', '%26')}`
      searchString += '&'
    })
  })

  if (!isEmpty(sort)) {
    searchString += `sort=${sort}&`
  }

  if (minPrice >= 0) {
    searchString += `min_price=${minPrice.toString()}&`
  }

  if (maxPrice >= 0) {
    searchString += `max_price=${maxPrice.toString()}&`
  }

  if (!isEmpty(searchString)) {
    searchString = searchString.substring(0, searchString.length - 1)
  }

  window.location.search = searchString.replace('#', '%23').replace('|', '%7C')

  if (isEmpty(searchString)) {
    window.history.pushState({}, document.title, window.location.pathname)
    window.location.reload()
  }
}

export default applyFilters
